import { createBackgroundJob } from '../../utils/BackgroundJobs';
import ImportWooCommerceOrderRetryMutation from 'graphql/mutations/sales/ImportWooCommerceOrderRetryMutation.graphql';
import { ImportedWooCommerceOrder } from '../../graphql/entities';
import { getActionProps } from '../../utils/getActionProps';
import getClientMutationId from '../../utils/getClientMutationId';

const preparePayload = (props: any) => {
  const actionProps = getActionProps(props, 'importedWooCommerceOrders', ImportedWooCommerceOrder.workspaceUrl);

  return {
    clientMutationId: getClientMutationId(),
    ...actionProps,
  };
};

const retryImport = (props: any) => {
  const input = preparePayload(props);

  createBackgroundJob(ImportWooCommerceOrderRetryMutation, input, props, null, 'Retrying import', () => {
    if (window.location.pathname.startsWith(ImportedWooCommerceOrder.workspaceUrl || '')) {
      window.location.reload();
    }
  });
};

export const workspace = [
  {
    description: 'Retry',
    allowMultiple: false,
    call: retryImport,
    dataFromProps: 'actionEntities',
    actionReference: 'WOOCOMMERCE_ORDERS_IMPORT',
  },
];
